export interface WorkerProject {
  projectId: string;
  projectName: string;
  isExempted: boolean;
  exemptedCourses: any[];
  alias: string;
}

export interface Course {
  courseId: string;
  courseName: string;
  description: string;
  courseStatusName: string;
  courseCompleted: number;
  courseAttempt: number;
  workerProjects: WorkerProject[];
  lastModifiedDate: string;
  courseValidityInDays: number;
  learnerCourseId: string;
  isCourseWillExpireIn60Days: boolean;
  workerCourseStatus: number;
  completionDate?: string;
  expirationDate?: string;
}

export enum CourseStatus {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
}

export enum TabIndex {
  ACTIVE = 0,
  EXPIRED = 1,
}

export enum SortType {
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  COMPLETION_DATE_ASC = 'COMPLETION_DATE_ASC',
  COMPLETION_DATE_DESC = 'COMPLETION_DATE_DESC',
  EXPIRATION_DATE_ASC = 'EXPIRATION_DATE_ASC',
  EXPIRATION_DATE_DESC = 'EXPIRATION_DATE_DESC',
}
